/**
 * 微前端配置文件
 */

const microAppMark = '/sub';

/**
 * 子应用配置
 * @param name 子应用名称 与子应用 package.json 中的 name 保持一致
 * @param activeRule 域名标识
 * @param port 开发本地端口号 备注：如发现404，可能端口被占用，建议查询后重新启动项目
 */
const microAppList = [
  // 基础服务
  {
    name: 'microAppBase',
    activeRule: '/base/',
    port: '3071',
  },
  // JT-流程引擎
  {
    name: 'microAppProcess',
    activeRule: '/process/',
    port: '3092',
  },
  // zigongcheng
  {
    name: 'microAppPublic',
    activeRule: '/public/',
    port: '5001',
  },
  // JT-统一权限
  {
    name: 'microAppPublicAuthority',
    activeRule: '/publicAuthority/',
    port: '3091',
  },
  // 自营-服务
  {
    name: 'microAppScmService',
    activeRule: '/scmService/',
    port: '3050',
  },
  // 自营-物流
  {
    name: 'microAppScmLogistics',
    activeRule: '/scmLogistics/',
    port: '3051',
  },
  // JT-统一消息
  {
    name: 'microAppPublicMessage',
    activeRule: '/publicMessage/',
    port: '3093',
  },
  // 元数据
  {
    name: 'microAppPublicMetadata',
    activeRule: '/publicMetadata/',
    port: '3089',
  },
  // console后台
  {
    name: 'microAppConsole',
    activeRule: '/console/',
    port: '3094',
  },
  // admin后台（雏鹰权限）
  {
    name: 'microAppAdmin',
    activeRule: '/admin/',
    port: '3095',
  },
  // admin后台（雏鹰权限）
  {
    name: 'microAppLive',
    activeRule: '/live/',
    port: '3096',
  },
];

export {
  microAppList,
  microAppMark,
};
